import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

export default ({ isLoading, text, loadingText, disabled = false, ...props }) => (
  <Button disabled={ disabled || isLoading } {...props}>
    { isLoading &&
      <Glyphicon glyph="refresh"
        className="spinning fa fa-refresh fa-spin"
        style={{
          marginRight:10,
        }}
      />
    }
    { ! isLoading ? text : loadingText }
  </Button>
);



// WEBPACK FOOTER //
// ./src/components/LoaderButton.js